import { Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';

import { EnvironmentService, HostContext } from '@hdms/shared/util-core';

import { HeaderConfigService, MenuStateService } from '../../../services';

const AEM_REDIRECT_URI = '/bin/servlets/hilti/languageSwitch';

@Component({
  selector: 'shrd-pf-ft-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectLanguageComponent implements OnInit {
  @Input() inContentBox: boolean;

  readonly currentLanguage = this.configService.activeLanguage;
  readonly availableLanguages = this.configService.languages;
  readonly inAemContext = inject(EnvironmentService).hostContext === HostContext.AEM;

  hrefPath: string;

  constructor(
    private readonly configService: HeaderConfigService,
    private readonly menuState: MenuStateService,
    private readonly cdr: ChangeDetectorRef,
    private readonly location: Location
  ) {
    this.location.onUrlChange(this.onUrlChanged.bind(this));
  }

  ngOnInit(): void {
    this.hrefPath = this.generateHrefPath(this.location.path());
  }

  switchLang(lang: string): boolean {
    if (lang) {
      this.configService.switchLanguage(lang);
      this.menuState.closeAll();
    }
    return !!lang;
  }

  private onUrlChanged(url: string): void {
    this.hrefPath = this.generateHrefPath(url);
    this.cdr.detectChanges();
  }

  private generateHrefPath(url: string): string {
    return this.inAemContext ? this.getRedirectQueryPath(url) : this.removeLangPrefix(url);
  }

  /**
   * When in AEM context, returns a redirectUrl containing the current locale and path
   * @param path
   * @private
   */
  private getRedirectQueryPath(path: string): string {
    return `${AEM_REDIRECT_URI}?locale=${this.currentLanguage.locale}&source=${encodeURIComponent(path)}&targetLang=`;
  }

  private removeLangPrefix(url: string): string {
    const rgx = new RegExp(`^/${this.currentLanguage.language}`);
    return this.location.normalize(url).replace(rgx, '');
  }
}
